import { Badge } from '@chakra-ui/react';
import Link from 'next/link';
import { memo } from 'react';

import { StatusBadgeProps } from './types';

const StatusBadge = memo(
  ({ data, state, stateOption, isMobile = false }: StatusBadgeProps) => {
    const badgeProps = {
      fontSize: isMobile ? 'xs' : '14px',
      rounded: 'lg',
      px: '2',
      py: '1',
      ...stateOption,
      ...(isMobile && {
        w: 'full',
        textAlign: 'center' as const,
      }),
    };

    const badgeContent = <Badge {...badgeProps}>{state}</Badge>;

    if (data.delivery_link && data.status === 'out_for_delivery') {
      return (
        <Link
          href={data.delivery_link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ width: isMobile ? '100%' : undefined }}
        >
          {badgeContent}
        </Link>
      );
    }

    return badgeContent;
  }
);

StatusBadge.displayName = 'StatusBadge';

export { StatusBadge };
